export enum AgreementType {
    IMPLICIT = 'IMPLICIT',
    EXPLICIT = 'EXPLICIT'
}